import React from 'react';
import Board from "./board/board"
const game = () => {
    return ( 
        <div className="game">
            <Board />
        </div>
     );
}
 
export default game;